import { apiCall } from '../compliance/api';

export const getIfrsMapping = async () => {
  const result = await apiCall('/comptabilite/ifrs-support/mappings');
  return result.data || [];
};

export const getIfrsStandards = async () => {
  const result = await apiCall('/comptabilite/ifrs-support/standards');
  return result.data || [];
};

export const getIfrsDifferences = async () => {
  const result = await apiCall('/comptabilite/ifrs-support/differences');
  return result.data || [];
};

export const createIfrsMapping = async (data) => {
  const now = new Date().toISOString();
  const payload = { ...data, created_at: now, updated_at: now };
  const result = await apiCall('/comptabilite/ifrs-support/mappings', 'POST', payload);
  return result.data;
};
